import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function callsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === 'ADD_CALLS') {
    return [].concat(_toConsumableArray(state), _toConsumableArray(action.calls.map(function (call) {
      return Object.assign(Object.assign({}, call), {
        address: call.address.toLowerCase()
      });
    })));
  } else if (action.type === 'UPDATE_CALLS') {
    return state.map(function (call) {
      if (call.chainId !== action.chainId || !action.updatedCalls.includes(call)) {
        return call;
      }
      var blockNumber = action.blockNumber;
      return Object.assign(Object.assign({}, call), {
        lastUpdatedBlockNumber: blockNumber
      });
    });
  } else {
    var finalState = state;
    var _iterator = _createForOfIteratorHelper(action.calls),
      _step;
    try {
      var _loop = function _loop() {
        var call = _step.value;
        var index = finalState.findIndex(function (x) {
          return x.address.toLowerCase() === call.address.toLowerCase() && x.data === call.data;
        });
        if (index !== -1) {
          finalState = finalState.filter(function (_, i) {
            return i !== index;
          });
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return finalState;
  }
}